module.exports = __webpack_public_path__ + "img/2022_dodge-challenger.22974e21.png";